export const loadConfig = async () => {
  const res = await fetch("/config.json");
  const config = await res.json();

  return config;
};
